import type { SectionDraftDetail, Suggestion } from '../../api/client'

export type { Suggestion }

export const openSuggestions = (d: Pick<SectionDraftDetail, 'suggestions'>): Suggestion[] =>
  (d.suggestions ?? []).filter((x) => x.status === 'open')

export function suggestionText(s: Pick<Suggestion, 'kind' | 'before' | 'after'>): { before: string; after: string; label: string } {
  return { before: s.before, after: s.after, label: s.kind === 'typo' ? 'Possible typo' : 'Suggested caption' }
}

/** The server refuses an accept when the sentence no longer reads as it did. */
export function isTextChanged(err: unknown): boolean {
  const e = err as { status?: number; detail?: { detail?: { code?: string } } } | null
  return e?.status === 409 && e.detail?.detail?.code === 'text_changed'
}

export const TEXT_CHANGED = 'The text changed since this was suggested — dismiss it or edit by hand.'

/** The photo a caption suggestion is for: its stored src, else (older drafts) the src of the
 *  body's figure with that asset id. Only https URLs are returned. */
export function captionPhoto(s: Pick<Suggestion, 'kind' | 'asset_id' | 'src'>, bodyHtml: string | null | undefined): string | null {
  if (s.kind !== 'caption') return null
  const ok = (u: string | undefined | null) => (u && /^https:\/\//i.test(u) ? u : null)
  if (ok(s.src)) return s.src as string
  if (s.asset_id == null || !bodyHtml) return null
  const m = new RegExp(`<figure[^>]*data-asset="${Number(s.asset_id)}"[^>]*>\\s*<img[^>]*\\ssrc="([^"]+)"`, 'i').exec(bodyHtml)
  return ok(m?.[1]?.replace(/&amp;/g, '&'))
}
